import {Injectable} from '@angular/core';
import {User} from '../models/user'
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {map, first} from 'rxjs/operators';
import {AnalyticsService} from '../dashboard/analytics.service';
import {AuthenticationService} from '../dashboard-login/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthUserResolver implements Resolve<User> {

  constructor(private analyticsService: AnalyticsService, private authenticationService: AuthenticationService, private _router: Router) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<User> | Promise<User> | User {
    if (!this.authenticationService.currentUserValue.value) {
      return this.authenticationService.authUser().pipe(map(
        res => {
          return res
        }
      ))
    } else {
        return this.authenticationService.currentUserValue.value
    }

  }

}
